<div class="inline-flex gap-2 items-center">
    <div class="status-{{ status }} size-3 rounded-full"></div>

    <span class="status-text-{{ status }} typo-body2">
        {{ text ?? ('status.' + status | translate) }}
    </span>
</div>
